
/* Irish Fashion Design - Product Zoom */

(() => {
  function initProductZoom() {
    document.querySelectorAll(
      'product-modal.product-media-modal'
    ).forEach((modal) => {
      if (modal.dataset.ifdZoomReady) return;
      modal.dataset.ifdZoomReady = 'true';

      const dialog = modal.querySelector(
        '.product-media-modal__dialog'
      );
      const images = Array.from(
        modal.querySelectorAll(
          '.product-media-modal__content > img'
        )
      );

      if (!dialog || !images.length) return;

      let currentImage = null;
      let scale = 1;
      let x = 0;
      let y = 0;
      let dragging = false;
      let startX = 0;
      let startY = 0;

      const controls = document.createElement('div');
      controls.className = 'ifd-zoom-controls';
      controls.innerHTML = `
        <button type="button" data-zoom="out"
          aria-label="Zoom out">−</button>
        <button type="button" class="ifd-reset"
          data-zoom="reset">Reset</button>
        <button type="button" data-zoom="in"
          aria-label="Zoom in">+</button>
      `;
      dialog.appendChild(controls);

      function getCurrentImage() {
        return modal.querySelector(
          '.product-media-modal__content > img.active'
        ) || images[0];
      }

      function resetImage(image) {
        if (!image) return;
        image.style.transform = '';
        image.classList.remove(
          'ifd-zoomed', 'ifd-dragging'
        );
      }

      function selectImage(image) {
        if (!image) return;

        if (currentImage !== image) {
          resetImage(currentImage);
          currentImage = image;
          scale = 1;
          x = 0;
          y = 0;
          dragging = false;
        }
      }

      function clampPosition() {
        if (!currentImage) return;

        const maxX =
          (currentImage.offsetWidth * (scale - 1)) / 2;
        const maxY =
          (currentImage.offsetHeight * (scale - 1)) / 2;

        x = Math.max(-maxX, Math.min(maxX, x));
        y = Math.max(-maxY, Math.min(maxY, y));
      }

      function updateImage() {
        if (!currentImage) return;

        clampPosition();

        currentImage.style.transform =
          `translate(${x}px, ${y}px) scale(${scale})`;

        currentImage.classList.toggle(
          'ifd-zoomed', scale > 1
        );
      }

      function changeZoom(amount) {
        selectImage(getCurrentImage());

        scale = Math.max(
          1,
          Math.min(3, Math.round((scale + amount) * 10) / 10)
        );

        if (scale === 1) {
          x = 0;
          y = 0;
        }

        updateImage();
      }

      function resetZoom() {
        selectImage(getCurrentImage());
        scale = 1;
        x = 0;
        y = 0;
        updateImage();
      }

      controls.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;

        const action = button.dataset.zoom;

        if (action === 'in') changeZoom(0.5);
        if (action === 'out') changeZoom(-0.5);
        if (action === 'reset') resetZoom();
      });

      // Prevent Dawn closing the modal when
      // the user releases the pointer on controls.
      controls.addEventListener('pointerup', (event) => {
        event.stopPropagation();
      });

      images.forEach((image) => {
        image.draggable = false;

        image.addEventListener('pointerdown', (event) => {
          selectImage(image);

          if (scale <= 1) return;
          if (event.pointerType === 'mouse' &&
              event.button !== 0) return;

          dragging = true;
          startX = event.clientX - x;
          startY = event.clientY - y;

          image.classList.add('ifd-dragging');
          image.setPointerCapture(event.pointerId);
          event.preventDefault();
        });

        image.addEventListener('pointermove', (event) => {
          if (!dragging || currentImage !== image) return;

          x = event.clientX - startX;
          y = event.clientY - startY;

          updateImage();
        });

        image.addEventListener('pointerup', (event) => {
          dragging = false;
          image.classList.remove('ifd-dragging');

          // Dawn closes image modals on mouse pointerup.
          event.stopPropagation();
        });

        image.addEventListener('pointercancel', () => {
          dragging = false;
          image.classList.remove('ifd-dragging');
        });

        image.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      });

      // Reset zoom whenever the modal opens.
      const observer = new MutationObserver(() => {
        if (modal.hasAttribute('open')) {
          images.forEach(resetImage);
          currentImage = null;
          scale = 1;
          x = 0;
          y = 0;
          dragging = false;
        }
      });

      observer.observe(modal, {
        attributes: true,
        attributeFilter: ['open']
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded', initProductZoom
    );
  } else {
    initProductZoom();
  }

  document.addEventListener(
    'shopify:section:load', initProductZoom
  );
})();
